import React from 'react'

const Success = () => {
  return (
      <div id='successAlert' className='mt-5 print-wrap alert alert-info d-none'>
          <p>
              Now that you have created a QR code, you can print this code onto your marketing material.
          </p>

          <a href='https://www.fastordernow.com/order/menu/cardswapp' target='_blank' rel='noreferrer'>Visit Our Store</a>
      </div>
  )
}

export default Success
